import { render, staticRenderFns } from "./EditClinicianClaims.vue?vue&type=template&id=2b297322&"
import script from "./EditClinicianClaims.vue?vue&type=script&lang=js&"
export * from "./EditClinicianClaims.vue?vue&type=script&lang=js&"
import style0 from "./EditClinicianClaims.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditClinicianClaims.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports